'use strict';

(function ($) {
  $(document).ready(function () {
      $('body').first().append('<div class="modal fade" id="external-links-handler-popup" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">' +
        '<div class="modal-dialog-cflungviewer" role="document">' +
        '<div class="modal-content">' +
        '<div class="header-content">' +
        '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
        '</div>' +
        (drupalSettings.external_links_handler.title ?
            '<div class="modal-header">' +
            '<h4 class="modal-title" id="myModalLabel">' + drupalSettings.external_links_handler.title + '</h4>' +
            '</div>' : ''
        ) +
        '<div class="modal-body">' + drupalSettings.external_links_handler.text.replace('!link', '<span id="elht"></span>') + '</div>' +
        '<div class="modal-footer">' +
        '<a href="#" class="btn-external-cfkademie btn-external" data-dismiss="modal">' + drupalSettings.external_links_handler.cancel + '</a>' +
        '<a href="javascript:;" target="_blank" class="confirm-external-link-handler">' + drupalSettings.external_links_handler.confirm + '</a>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>');

      var $popup = $('#external-links-handler-popup');
      var $confirm = $popup.find('.confirm-external-link-handler');

      $('.confirm-external-link-handler').click(function () {
        $('#external-links-handler-popup').modal('hide');
      });
      var external_domains_whitelist = [];
      if (drupalSettings.external_links_handler.external_domains_whitelist) {
        external_domains_whitelist = drupalSettings.external_links_handler.external_domains_whitelist.split(',');
      }

      Array.from(document.querySelectorAll('a')).forEach(function (a) {
        var type = location.hostname === a.hostname || !a.hostname.length ? 'local' : 'external';
        var $a = $(a);

        if (type == 'external' && drupalSettings.external_links_handler.external_domains_whitelist) {
          external_domains_whitelist.forEach(function (domain) {
            domain = $.trim(domain);
            if (a.hostname === domain) {
              type = 'local';
            }
          });
        }

        if (type == 'external') {
          $a.attr('data-toggle', 'modal').attr('data-target', '#external-links-handler-popup');
          $a.attr('data-href', $a.attr('href'));
          $a.attr('href', 'javascript:;');

          $a.click(function (e) {
            console.log('aicisa');
            $('#elht').html($a.data('href'));
            $confirm.attr('href', $a.data('href'));
          });
        }
      });
  });
})(jQuery);
